import React from 'react';
import classNames from 'classnames';

import { Arrow } from '@/icons/index';
import { ActiveLink } from '@/ui/index';

import styles from '../styles.module.scss';

const NavItem = ({ item, handleOpenMenu }) => {
  const [active, setActive] = React.useState(false);

  const renderItem = (subCategory, subCategoryIndex) => {
    return (
      <ActiveLink
        handleOpenMenu={handleOpenMenu}
        key={subCategoryIndex}
        href={`/${subCategory?.slug}`}
        itemScope
        itemType='https://schema.org/SiteNavigationElement'
      >
        <span title={subCategory?.text} className={styles.navItem}>
          {subCategory?.text}
        </span>
      </ActiveLink>
    );
  };

  return (
    <div
      className={classNames([styles.item, { [styles.active]: active }])}
      itemScope
      itemType='https://schema.org/SiteNavigationElement'
    >
      <div className={styles.navButton}>
        {item?.slug ? (
          <ActiveLink handleOpenMenu={handleOpenMenu} href={`/${item?.slug}`}>
            <a title={item?.text} aria-label={item?.text}>
              {item?.text}
            </a>
          </ActiveLink>
        ) : (
          <a
            href={item?.external_link}
            title={item?.text}
            aria-label={item?.text}
            rel='noreferrer'
            target='_blank'
          >
            {item?.text}
          </a>
        )}
        {item?.children?.length > 0 && (
          <button
            className={styles.arrow}
            aria-label='Bakcell'
            onClick={() => setActive(!active)}
          >
            <Arrow width={12} className={styles.arrowSvg} />
          </button>
        )}
      </div>
      {item?.children?.length > 0 && (
        <div className={styles.nav}>{item?.children?.map(renderItem)}</div>
      )}
    </div>
  );
};

export default NavItem;
